import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import Panel from './panel';
import { panelFilterStyles } from './styles';

export function PanelFilter(props) {
  return <Panel elevation={0} {...props} />;
}

export default withStyles(panelFilterStyles)(PanelFilter);
